// import React from "react"
// import { DateRangePicker } from "materialui-daterange-picker";
// import ReactSelect from "react-select";
// import { TextField, Tooltip } from "@material-ui/core";
// import { CSVLink } from "react-csv";
// import CookieManager from "../../services/CookieManager";
// import DownloadIcon from "@material-ui/icons/GetAppSharp";
// import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

// const FilterComp = (props) => {
//     const [dateRangeVisible, setDateRangeVisible] = React.useState(false);
//     const toggle = () => setDateRangeVisible(!dateRangeVisible);
//     const userData = CookieManager.getCookie("user-data")?.length ? JSON.parse(CookieManager.getCookie("user-data")) : null;
//     let csvFileName = props.buttonTitle?.includes('Licenses') ? `Licenses-${userData._id}-${new Date().getTime()}` : `Projects-${userData._id}-${new Date().getTime()}`;

//     // Simple React Select styles
//     const customSelectStyles = {
//         control: (provided, state) => ({
//             ...provided,
//             minHeight: '40px',
//             fontSize: '14px',
//             borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
//             borderWidth: '1px',
//             borderRadius: '8px',
//             boxShadow: 'none',
//             '&:hover': {
//                 borderColor: '#d1d5db'
//             },
//             backgroundColor: '#ffffff'
//         }),
//         placeholder: (provided) => ({
//             ...provided,
//             fontSize: '14px',
//             color: '#9ca3af'
//         }),
//         multiValue: (provided) => ({
//             ...provided,
//             backgroundColor: '#e5e7eb',
//             borderRadius: '4px',
//             fontSize: '12px'
//         }),
//         multiValueLabel: (provided) => ({
//             ...provided,
//             color: '#374151',
//             fontSize: '12px'
//         }),
//         multiValueRemove: (provided) => ({
//             ...provided,
//             color: '#6b7280',
//             '&:hover': {
//                 backgroundColor: '#d1d5db',
//                 color: '#374151'
//             }
//         })
//     };

//     return (
//         <>
//             <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4">
//                 {/* Mobile Layout */}
//                 <div className='block lg:hidden'>
//                     <div className="space-y-4">
//                         {/* User Selection */}
//                         <div className='w-full'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">
//                                 <div className="flex items-center gap-2">
//                                     <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                                     </svg>
//                                     User(s):
//                                 </div>
//                             </label>
//                             <ReactSelect
//                                 value={props.selectedUsers}
//                                 options={props.users}
//                                 isMulti={true}
//                                 isSearchable={true}
//                                 onChange={props.handleUserSelection}
//                                 styles={customSelectStyles}
//                                 placeholder="Search user..."
//                                 className="w-full"
//                             />
//                         </div>

//                         {/* Date Range */}
//                         <div className="w-full">
//                             <h4 className="text-sm font-medium text-gray-700 mb-3">Date Range</h4>
//                             <div className="grid grid-cols-2 gap-3">
//                                 <div>
//                                     <label className="block text-sm text-gray-600 mb-1">From:</label>
//                                     <div 
//                                         className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
//                                         onClick={() => toggle()}
//                                     >
//                                         <TextField
//                                             value={props.startDate.toLocaleDateString('en-GB')}
//                                             onClick={toggle}
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             InputProps={{
//                                                 style: { 
//                                                     fontSize: '14px',
//                                                     cursor: 'pointer',
//                                                     backgroundColor: '#fafafa',
//                                                     border: 'none'
//                                                 },
//                                                 readOnly: true,
//                                                 startAdornment: <CalendarTodayIcon className="text-gray-400 mr-2" style={{ fontSize: '16px' }} />
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
                                
//                                 <div>
//                                     <label className="block text-sm text-gray-600 mb-1">To:</label>
//                                     <div 
//                                         className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
//                                         onClick={() => toggle()}
//                                     >
//                                         <TextField
//                                             value={props.endDate.toLocaleDateString('en-GB')}
//                                             onClick={toggle}
//                                             variant="outlined"
//                                             size="small"
//                                             fullWidth
//                                             InputProps={{
//                                                 style: { 
//                                                     fontSize: '14px',
//                                                     cursor: 'pointer',
//                                                     backgroundColor: '#fafafa',
//                                                     border: 'none'
//                                                 },
//                                                 readOnly: true,
//                                                 startAdornment: <CalendarTodayIcon className="text-gray-400 mr-2" style={{ fontSize: '16px' }} />
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Action Buttons */}
//                         <div className='w-full flex flex-col space-y-3'>
//                             {/* CSV Download Button - Fixed */}
//                             {props.csvData?.length > 0 && 
//                                 <CSVLink
//                                     data={props.csvData}
//                                     filename={`${csvFileName}.csv`}
//                                     target="_blank"
//                                     className="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors duration-200"
//                                 >
//                                     <DownloadIcon style={{ fontSize: '18px' }} />
//                                     <span>Download CSV</span>
//                                 </CSVLink>
//                             }
                            
//                             <button
//                                 onClick={props.loadData}
//                                 className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200"
//                             > 
//                                 {props.buttonTitle}
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Desktop Layout - Matching Second Image */}
//                 <div className='hidden lg:flex lg:items-end lg:gap-4'>
//                     {/* User Selection */}
//                     <div className='flex-1 max-w-xs'>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             <div className="flex items-center gap-2">
//                                 <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                                 </svg>
//                                 User(s):
//                             </div>
//                         </label>
//                         <ReactSelect
//                             value={props.selectedUsers}
//                             options={props.users}
//                             isMulti={true}
//                             isSearchable={true}
//                             onChange={props.handleUserSelection}
//                             styles={customSelectStyles}
//                             placeholder="Search user..."
//                         />
//                     </div>

//                     {/* Date Range */}
//                     <div className="flex gap-3">
//                         <div className='w-36'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">From:</label>
//                             <div 
//                                 className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
//                                 onClick={() => toggle()}
//                             >
//                                 <TextField
//                                     value={props.startDate.toLocaleDateString('en-GB')}
//                                     onClick={toggle}
//                                     variant="outlined"
//                                     size="small"
//                                     fullWidth
//                                     InputProps={{
//                                         style: { 
//                                             fontSize: '14px',
//                                             cursor: 'pointer',
//                                             backgroundColor: '#fafafa',
//                                             border: 'none'
//                                         },
//                                         readOnly: true,
//                                         startAdornment: <CalendarTodayIcon className="text-gray-400 mr-1" style={{ fontSize: '16px' }} />
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                         <div className='w-36'>
//                             <label className="block text-sm font-medium text-gray-700 mb-2">To:</label>
//                             <div 
//                                 className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
//                                 onClick={() => toggle()}
//                             >
//                                 <TextField
//                                     value={props.endDate.toLocaleDateString('en-GB')}
//                                     onClick={toggle}
//                                     variant="outlined"
//                                     size="small"
//                                     fullWidth
//                                     InputProps={{
//                                         style: { 
//                                             fontSize: '14px',
//                                             cursor: 'pointer',
//                                             backgroundColor: '#fafafa',
//                                             border: 'none'
//                                         },
//                                         readOnly: true,
//                                         startAdornment: <CalendarTodayIcon className="text-gray-400 mr-1" style={{ fontSize: '16px' }} />
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                     </div>

//                     {/* Actions */}
//                     <div className='flex items-center gap-3'>
//                         {/* CSV Download Button - Fixed */}
//                         {props.csvData?.length > 0 && 
//                             <CSVLink
//                                 data={props.csvData}
//                                 filename={`${csvFileName}.csv`}
//                                 target="_blank"
//                                 className="flex items-center justify-center p-2.5 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-lg transition-colors duration-200"
//                             >
//                                 <DownloadIcon style={{ fontSize: '20px', color: '#374151' }} />
//                             </CSVLink>
//                         }
                        
//                         <button
//                             onClick={props.loadData}
//                             className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors duration-200 whitespace-nowrap"
//                         > 
//                             {props.buttonTitle}
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             {/* Your Exact Calendar Modal Design */}
//             {dateRangeVisible && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//                     <div className="bg-white rounded-2xl shadow-2xl max-w-full max-h-full overflow-auto">
//                         <DateRangePicker
//                             open={dateRangeVisible}
//                             toggle={toggle}
//                             onChange={(range) => props.setDateRangeValues(range)}
//                         />
//                     </div>
//                 </div>
//             )}

//             {/* Basic Calendar Styles */}
//             <style jsx global>{`
//                 /* Remove toolbar */
//                 .MuiPickersDateRangePickerToolbar-root {
//                     display: none !important;
//                 }

//                 /* Basic calendar styling */
//                 .MuiPickersDateRangePickerViewDesktop-container {
//                     display: flex !important;
//                     gap: 20px !important;
//                     justify-content: center !important;
//                     padding: 20px !important;
//                 }

//                 .MuiPickersCalendar-root {
//                     width: 280px !important;
//                 }

//                 .MuiPickersCalendarHeader-root {
//                     padding: 12px !important;
//                     background: #ffffff !important;
//                 }

//                 .MuiPickersCalendarHeader-switchHeader {
//                     margin: 0 8px !important;
//                     display: flex !important;
//                     align-items: center !important;
//                     justify-content: space-between !important;
//                 }

//                 .MuiPickersCalendarHeader-iconButton {
//                     background: #f3f4f6 !important;
//                     color: #374151 !important;
//                     width: 32px !important;
//                     height: 32px !important;
//                     border-radius: 6px !important;
//                 }

//                 .MuiPickersCalendarHeader-iconButton:hover {
//                     background: #e5e7eb !important;
//                 }

//                 .MuiPickersCalendarHeader-transitionContainer {
//                     font-size: 16px !important;
//                     font-weight: 600 !important;
//                     color: #1f2937 !important;
//                 }

//                 .MuiPickersDay-root {
//                     width: 36px !important;
//                     height: 36px !important;
//                     font-size: 14px !important;
//                     border-radius: 6px !important;
//                 }

//                 .MuiPickersDay-root:hover {
//                     background-color: #f3f4f6 !important;
//                 }

//                 .MuiPickersDay-daySelected {
//                     background-color: #3b82f6 !important;
//                     color: white !important;
//                 }

//                 .MuiPickersDay-dayInRange {
//                     background-color: #dbeafe !important;
//                     color: #1e40af !important;
//                 }

//                 @media (max-width: 1024px) {
//                     .MuiPickersDateRangePickerViewDesktop-container {
//                         flex-direction: column !important;
//                         gap: 16px !important;
//                         padding: 16px !important;
//                     }
                    
//                     .MuiPickersCalendar-root {
//                         width: 260px !important;
//                     }
//                 }

//                 @media (max-width: 640px) {
//                     .MuiPickersCalendar-root {
//                         width: 240px !important;
//                     }
                    
//                     .MuiPickersDay-root {
//                         width: 32px !important;
//                         height: 32px !important;
//                         font-size: 12px !important;
//                     }
//                 }
//             `}</style>
//         </>
//     )
// }

// export default FilterComp




// FilterComp Component - Complete Fixed Version
import React from "react"
import { DateRangePicker } from "materialui-daterange-picker";
import ReactSelect, { components } from "react-select";
import { TextField, Tooltip } from "@material-ui/core";
import { CSVLink } from "react-csv";
import CookieManager from "../../services/CookieManager";
import DownloadIcon from "@material-ui/icons/GetAppSharp";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import { ErrorToast } from '../../pure-components/CustomToast';
import { toast } from 'react-toastify';

const FilterComp = (props) => {
    const [dateRangeVisible, setDateRangeVisible] = React.useState(false);
    const toggle = () => setDateRangeVisible(!dateRangeVisible);
    const userData = CookieManager.getCookie("user-data")?.length ? JSON.parse(CookieManager.getCookie("user-data")) : null;
    let csvFileName = props.buttonTitle?.includes('Licenses') ? `Licenses-${userData._id}-${new Date().getTime()}` : `Projects-${userData._id}-${new Date().getTime()}`;

    const allOption = { label: "Select All", value: "*" };

    // Custom Option component for checkboxes
    const CustomOption = (optionProps) => {
        if (optionProps.data.value === "*") {
            const allSelected = props.selectedUsers?.length === props.users?.length;
            return (
                <div 
                    {...optionProps.innerProps} 
                    className="react-select__option"
                    style={{ cursor: "pointer", display: "flex", alignItems: "center", padding: "8px 12px" }}
                    onClick={() => {
                        if (allSelected) {
                            // Don't allow deselecting all users
                            toast(({ closeToast }) => <ErrorToast message={`At least one user must remain selected.`} />);
                        } else {
                            props.handleUserSelection(props.users);
                        }
                    }}
                >
                    <input 
                        type="checkbox" 
                        checked={allSelected} 
                        readOnly 
                        style={{ marginRight: "8px" }} 
                    />
                    {optionProps.label}
                </div>
            );
        } else {
            return (
                <components.Option {...optionProps}>
                    <input 
                        type="checkbox" 
                        checked={optionProps.isSelected} 
                        onChange={() => null} 
                        style={{ marginRight: "8px" }} 
                    />
                    {optionProps.label}
                </components.Option>
            );
        }
    };

    // FIXED: Handle user selection with validation
    const handleUserSelectionWithValidation = (selectedOptions) => {
        // If trying to deselect all, prevent it and show message
        if (!selectedOptions || selectedOptions.length === 0) {
            toast(({ closeToast }) => <ErrorToast message={`At least one user must be selected.`} />);
            return;
        }
        props.handleUserSelection(selectedOptions);
    };

    // FIXED: Handle load data with validation
    const handleLoadData = () => {
        if (!props.selectedUsers || props.selectedUsers.length === 0) {
            toast(({ closeToast }) => <ErrorToast message={`Please select at least one user before loading data.`} />);
            return;
        }
        props.loadData();
    };

    // Simple React Select styles
    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '40px',
            fontSize: '14px',
            borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
            borderWidth: '1px',
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#d1d5db'
            },
            backgroundColor: '#ffffff'
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: '14px',
            color: '#9ca3af'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#e5e7eb',
            borderRadius: '4px',
            fontSize: '12px'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#374151',
            fontSize: '12px'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#6b7280',
            '&:hover': {
                backgroundColor: '#d1d5db',
                color: '#374151'
            }
        })
    };

    return (
        <>
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4">
                {/* Mobile Layout */}
                <div className='block lg:hidden'>
                    <div className="space-y-4">
                        {/* User Selection */}
                        <div className='w-full'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                <div className="flex items-center gap-2">
                                    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    User(s):
                                </div>
                            </label>
                            <ReactSelect
                                value={props.selectedUsers}
                                options={[allOption, ...props.users]}
                                isMulti={true}
                                isSearchable={true}
                                onChange={handleUserSelectionWithValidation}
                                styles={customSelectStyles}
                                placeholder="Search user..."
                                className="w-full"
                                components={{ Option: CustomOption }}
                                hideSelectedOptions={false}
                                closeMenuOnSelect={false}
                                isClearable={false}
                            />
                        </div>

                        {/* Date Range */}
                        <div className="w-full">
                            <h4 className="text-sm font-medium text-gray-700 mb-3">Date Range</h4>
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="block text-sm text-gray-600 mb-1">From:</label>
                                    <div 
                                        className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
                                        onClick={() => toggle()}
                                    >
                                        <TextField
                                            value={props.startDate ? props.startDate.toLocaleDateString('en-GB') : 'dd/mm/yyyy'}
                                            onClick={toggle}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            InputProps={{
                                                style: { 
                                                    fontSize: '14px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#fafafa',
                                                    border: 'none'
                                                },
                                                readOnly: true,
                                                startAdornment: <CalendarTodayIcon className="text-gray-400 mr-2" style={{ fontSize: '16px' }} />
                                            }}
                                        />
                                    </div>
                                </div>
                                
                                <div>
                                    <label className="block text-sm text-gray-600 mb-1">To:</label>
                                    <div 
                                        className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
                                        onClick={() => toggle()}
                                    >
                                        <TextField
                                            value={props.endDate ? props.endDate.toLocaleDateString('en-GB') : 'dd/mm/yyyy'}
                                            onClick={toggle}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            InputProps={{
                                                style: { 
                                                    fontSize: '14px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#fafafa',
                                                    border: 'none'
                                                },
                                                readOnly: true,
                                                startAdornment: <CalendarTodayIcon className="text-gray-400 mr-2" style={{ fontSize: '16px' }} />
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className='w-full flex flex-col space-y-3'>
                            {/* CSV Download Button */}
                            {props.csvData?.length > 0 && 
                                <CSVLink
                                    data={props.csvData}
                                    filename={`${csvFileName}.csv`}
                                    target="_blank"
                                    className="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition-colors duration-200"
                                >
                                    <DownloadIcon style={{ fontSize: '18px' }} />
                                    <span>Download CSV</span>
                                </CSVLink>
                            }
                            
                            <button
                                onClick={handleLoadData}
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200"
                            > 
                                {props.buttonTitle}
                            </button>
                            <button
                                onClick={props.clearFilter}
                                className="w-full bg-gray-600 hover:bg-gray-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200"
                            > 
                                Clear Filter
                            </button>
                        </div>
                    </div>
                </div>

                {/* Desktop Layout - Matching Second Image */}
                <div className='hidden lg:flex lg:items-end lg:gap-4'>
                    {/* User Selection */}
                    <div className='flex-1 max-w-xs'>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            <div className="flex items-center gap-2">
                                <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                User(s):
                            </div>
                        </label>
                        <ReactSelect
                            value={props.selectedUsers}
                            options={[allOption, ...props.users]}
                            isMulti={true}
                            isSearchable={true}
                            onChange={handleUserSelectionWithValidation}
                            styles={customSelectStyles}
                            placeholder="Search user..."
                            components={{ Option: CustomOption }}
                            hideSelectedOptions={false}
                            closeMenuOnSelect={false}
                            isClearable={false}
                        />
                    </div>

                    {/* Date Range */}
                    <div className="flex gap-3">
                        <div className='w-36'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">From:</label>
                           <div 
                                className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
                                onClick={() => toggle()}
                            >
                                <TextField
                                    value={props.startDate ? props.startDate.toLocaleDateString('en-GB') : 'dd/mm/yyyy'}
                                    onClick={toggle}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        style: { 
                                            fontSize: '14px',
                                            cursor: 'pointer',
                                            backgroundColor: '#fafafa',
                                            border: 'none'
                                        },
                                        readOnly: true,
                                        startAdornment: <CalendarTodayIcon className="text-gray-400 mr-1" style={{ fontSize: '16px' }} />
                                    }}
                                />
                            </div>
                        </div>
                        <div className='w-36'>
                            <label className="block text-sm font-medium text-gray-700 mb-2">To:</label>
                            <div 
                                className="relative border border-gray-300 rounded-lg overflow-hidden cursor-pointer hover:border-gray-400 transition-colors"
                                onClick={() => toggle()}
                            >
                                <TextField
                                    value={props.endDate ? props.endDate.toLocaleDateString('en-GB') : 'dd/mm/yyyy'}
                                    onClick={toggle}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    InputProps={{
                                        style: { 
                                            fontSize: '14px',
                                            cursor: 'pointer',
                                            backgroundColor: '#fafafa',
                                            border: 'none'
                                        },
                                        readOnly: true,
                                        startAdornment: <CalendarTodayIcon className="text-gray-400 mr-1" style={{ fontSize: '16px' }} />
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className='flex items-center gap-3'>
                        {/* CSV Download Button */}
                        {props.csvData?.length > 0 && 
                            <CSVLink
                                data={props.csvData}
                                filename={`${csvFileName}.csv`}
                                target="_blank"
                                className="flex items-center justify-center p-2.5 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-lg transition-colors duration-200"
                            >
                                <DownloadIcon style={{ fontSize: '20px', color: '#374151' }} />
                            </CSVLink>
                        }
                        
                        <button
                            onClick={handleLoadData}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors duration-200 whitespace-nowrap"
                        > 
                            {props.buttonTitle}
                        </button>
                        <button
                            onClick={props.clearFilter}
                            className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors duration-200 whitespace-nowrap"
                        > 
                            Clear Filter
                        </button>
                    </div>
                </div>
            </div>

            {/* Calendar Modal */}
            {dateRangeVisible && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-full max-h-full overflow-auto">
                        <DateRangePicker
                            open={dateRangeVisible}
                            toggle={toggle}
                            onChange={(range) => props.setDateRangeValues(range)}
                        />
                    </div>
                </div>
            )}

            {/* Calendar Styles */}
            <style jsx global>{`
                /* Remove toolbar */
                .MuiPickersDateRangePickerToolbar-root {
                    display: none !important;
                }

                /* Basic calendar styling */
                .MuiPickersDateRangePickerViewDesktop-container {
                    display: flex !important;
                    gap: 20px !important;
                    justify-content: center !important;
                    padding: 20px !important;
                }

                .MuiPickersCalendar-root {
                    width: 280px !important;
                }

                .MuiPickersCalendarHeader-root {
                    padding: 12px !important;
                    background: #ffffff !important;
                }

                .MuiPickersCalendarHeader-switchHeader {
                    margin: 0 8px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: space-between !important;
                }

                .MuiPickersCalendarHeader-iconButton {
                    background: #f3f4f6 !important;
                    color: #374151 !important;
                    width: 32px !important;
                    height: 32px !important;
                    border-radius: 6px !important;
                }

                .MuiPickersCalendarHeader-iconButton:hover {
                    background: #e5e7eb !important;
                }

                .MuiPickersCalendarHeader-transitionContainer {
                    font-size: 16px !important;
                    font-weight: 600 !important;
                    color: #1f2937 !important;
                }

                .MuiPickersDay-root {
                    width: 36px !important;
                    height: 36px !important;
                    font-size: 14px !important;
                    border-radius: 6px !important;
                }

                .MuiPickersDay-root:hover {
                    background-color: #f3f4f6 !important;
                }

                .MuiPickersDay-daySelected {
                    background-color: #3b82f6 !important;
                    color: white !important;
                }

                .MuiPickersDay-dayInRange {
                    background-color: #dbeafe !important;
                    color: #1e40af !important;
                }

                @media (max-width: 1024px) {
                    .MuiPickersDateRangePickerViewDesktop-container {
                        flex-direction: column !important;
                        gap: 16px !important;
                        padding: 16px !important;
                    }
                    
                    .MuiPickersCalendar-root {
                        width: 260px !important;
                    }
                }

                @media (max-width: 640px) {
                    .MuiPickersCalendar-root {
                        width: 240px !important;
                    }
                    
                    .MuiPickersDay-root {
                        width: 32px !important;
                        height: 32px !important;
                        font-size: 12px !important;
                    }
                }
            `}</style>
        </>
    )
}

export default FilterComp